import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { selectPaymentCategoryTranslation } from 'state/reducers/payment-categories.reducer';
import { MultiProps, PaymentCategoryOption } from './types';
import { formatPaymentCategory } from 'services/payment-categories.service';
import MultiSelectPicker from 'components/MultiSelectPicker';

/**
 * Payment Category Picker Component
 * Multi-select dropdown for selecting payment categories with hierarchical display.
 * Uses the generic MultiSelectPicker with payment category-specific formatting.
 */
export default function PaymentCategoryPicker(props: MultiProps) {
	const {
		value,
		onChange,
		error,
		helperText,
		disabled,
		label,
		hideTitle = false,
		required = false,
		options = [],
		loading = false,
		noOptions = false,
	} = props;

	const t = useAppSelector(selectTranslations);
	const categoryTranslation = useAppSelector(selectPaymentCategoryTranslation);

	return (
		<MultiSelectPicker<string, PaymentCategoryOption>
			value={value}
			onChange={onChange}
			options={options}
			getOptionValue={(opt) => opt.id}
			renderOptionLabel={(opt) => formatPaymentCategory(opt, opt.id, categoryTranslation)}
			label={label || t('page.accounts.new_account.customer.payment_categories.label')}
			title={t('page.accounts.new_account.customer.payment_categories.title')}
			hideTitle={hideTitle}
			required={required}
			disabled={disabled}
			loading={loading}
			noOptions={noOptions}
			noOptionsText={t('page.payment_categories.message.emptyCategories')}
			error={error}
			helperText={helperText}
			direction="rtl"
		/>
	);
}
